module.exports = __webpack_public_path__ + "static/media/IQ.125dff1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/IQ.svg
// module id = 279
// module chunks = 0